import { useQuery, useQueryClient } from "@tanstack/react-query";
import { QUERIES_KEYS } from "queries";
import { ksefApi } from "./ksefApi";

export const useKsefIntegrations = () => {
  const queryClient = useQueryClient();
  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.KSEF_INTEGRATIONS(),
    queryFn: () => ksefApi.fetch(),
  });

  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: QUERIES_KEYS.KSEF_INTEGRATIONS() });
  };

  return { invalidate, isLoading, isFetching, integrations: data?.data ?? [] };
};
